import domReady from '../utils/domReady.js'

function socialWindow (url) {
  const left = (screen.width - 570) / 2
  const top = (screen.height - 570) / 2
  const params = 'menubar=no,toolbar=no,status=no,width=570,height=570,top=' + top + ',left=' + left
  // Setting 'params' to an empty string will launch
  // content in a new tab or window rather than a pop-up.
  // params = "";
  window.open(url, 'NewWindow', params)
}

function setShareLinks () {
  const pageUrl = encodeURIComponent(document.URL)
  const tweet = encodeURIComponent($("meta[name='twitter:title']").attr('content') + '—' + $("meta[name='description']").attr('content'))
  const twitterHandle = encodeURIComponent($("meta[name='twitter:site']").attr('content'))
  $('.social-share.facebook').on('click', function (e) {
    e.preventDefault()
    const url = 'https://www.facebook.com/sharer.php?u=' + pageUrl
    socialWindow(url)
  })
}

domReady(() => {
  setShareLinks()
})
